import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import UserDateTimezoneFormat from '../../../components/user-date-timezone-format';

const name = <FormattedMessage {...messages.createDateUTCColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.createDateUTCColumnHeader,
  name,
  render: (data) => {
    const { createDateUTC } = data;
    return createDateUTC && <UserDateTimezoneFormat dateTime={createDateUTC} />;
  },
};
